export default {
  data() {
    return {
      dragging: false,
      pointerType: 'mouse',
      initialClientX: 0,
      scrolling: 0,
    };
  },
  methods: {
    start(eventType, clientX) {
      this.dragging = true;
      this.initialClientX = clientX;
      this.pointerType = eventType;
    },
    end() {
      this.dragging = false;
    },
    startScrolling(e) {
      this.scrolling = e;
    },
    endScrolling() {
      this.scrolling = 0;
    },
  },
};
